<template>
  <div v-if="events.data && events.data.count > 0" id="view-community-events-holder" class="landing-community-events-holder" style="position: relative">
    <div class="carousel_title" style="font-size: 20px; color: var(--text-color); font-weight: 600">My Community Tournaments
      <a class="view_all_event" :href="routePubgEvents('community')">See All</a>
    </div>
    <event-slider :events="events" :is-grid-view="false" page="landing" slide-to-show="4" />
  </div>
</template>

<script>
import { component } from '../../../../../mixins/component';
import EventSlider from '../../../../../components/events/EventSlider';

export default {
  components: { EventSlider },
  mixins: [component],
  props: {
    events: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
